import { axios as axiosPol } from '../../plugins/axios-pol'

export default {
  namespaced: true,

  state: {
    reimpresionCredencial: [],
  },

  getters: {
    getReimpresionCredencial: (state) => {
      return state.reimpresionCredencial
    },
  },

  mutations: {
    SET_REIMPRESION_CREDENCIAL(state, reimpresionCredencial) {
      state.reimpresionCredencial = reimpresionCredencial
    },
  },

  actions: {
    fetchReimpresionCredencialByPersonal: async function ({ commit }, idPersonal) {
      try {
        const response = await axiosPol.get(`/personal/api/EstadoFuerza/personal/${idPersonal}/reimpresionCredencial`)
        commit('SET_REIMPRESION_CREDENCIAL', response.data.data)
      } catch (error) {
        console.log(error)
      }
    },

    saveReimpresionCredencial: async function ({ commit }, formData) {
      try {
        await axiosPol.post(
          `/personal/api/EstadoFuerza/personal/${formData.get('fk_idPersonal')}/reimpresionCredencial`,
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        )
      } catch (error) {
        console.log(error)
      }
    },

    updateReimpresionCredencial: async function ({ commit }, reimpresionCredencial) {
      try {
        await axiosPol.put(
          `/personal/api/EstadoFuerza/personal/${reimpresionCredencial.idPersonal}/reimpresionCredencial/${reimpresionCredencial.id}`,
          reimpresionCredencial
        )
      } catch (error) {
        console.log(error)
      }
    },
  },
}
